/* template */
<template><card-item :goods="(goodsInfo)"></card-item></template>

/* styles */
/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { createForecast } from '../../lib/js/goods'
import { isPassenger } from '../../lib/js/env'
import { EnumGoodsDetailIsSpike } from '../../lib/webx/defines'
createComponent({
  properties: {
    goods: Object,
  },
  data: {
    goodsInfo: {},
  },
  computed: {
    isSoldout() {
      if (this.goods.is_spike === 3) { // 拼团商品
        return this.goods.single_balance_left === 0 && this.goods.group_balance_left === 0
      }
      return this.goods.balance_left === 0
    },
  },
  attached() {
    if (this.goods.is_spike !== 0 && this.isSoldout !== 0) { // 秒杀或拼团商品
      const {
        startSecRegular,
        currentSecRegular,
        startTimeGap,
        endTimeGap,
        dayText,
        startObj,
      } = createForecast(this.goods.start_time * 1000, this.goods.current_time * 1000, this.goods.end_time * 1000)
      let timeText = ''
      if (endTimeGap <= 0) {
        timeText = this.$t('common.ended')
      } else if (startSecRegular - currentSecRegular >= 24 * 60 * 60 * 1000 * 2) { // 距开始大于等于两个自然日
        timeText = `${dayText}${startObj.hour}:${startObj.minute} ` + (this.goods.is_spike === 3 ? this.$t('common.toGroup') : this.$t('common.snapUp'))
      } else if (startSecRegular - currentSecRegular >= 24 * 60 * 60 * 1000) { // 第二天
        timeText = this.$t('common.tomorrow') + ` ${startObj.hour}:${startObj.minute} ` + (this.goods.is_spike === 3 ? this.$t('common.toGroup') : this.$t('common.snapUp'))
      } else if (startTimeGap > 0) { // 当天
        timeText = this.$t('common.today') + ` ${startObj.hour}:${startObj.minute} ` + (this.goods.is_spike === 3 ? this.$t('common.toGroup') : this.$t('common.snapUp'))
      } else if (startTimeGap <= 0) {
        timeText = (this.goods.is_spike === 3 ? this.$t('common.gotoGroup') : this.$t('common.buyRushNow'))
      } else {
        timeText = ''
      }
      this.goods.buy_time_text = timeText
    }
    if (this.goods.logo_info && this.goods.logo_info.logos && this.goods.logo_info.logos.length > 3) {
      this.goods.logo_info.logos = this.goods.logo_info.logos.slice(0, 3)
    }
    this.goods.original_price = this.goods.original_price / 100
    if (this.goods.is_spike === 3) {
      this.goods.price = this.goods.group_price / 100
    } else if (this.goods.is_spike === EnumGoodsDetailIsSpike.Route){
      this.goods.price = this.goods.route_price / 100
    } else {
      this.goods.price = this.goods.price / 100
    }
    if (this.goods.goods_type === 2) {
      if (isPassenger()) {
        window.mallTrackEvent('na_changxing_card_sw')
      } else {
        window.mallTrackEvent('w_changxing_card_sw')
      }
    }
    this.goodsInfo = this.goods
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "card-item5f98f9b0",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'card-item':getComponent(require("../mall-ui/card-item/index.mpx?component=true&componentId=index4cd5f06a"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
